export default __webpack_public_path__ + "static/media/wrong-network.8a463d6a.png";